<template>
  <div class="mx-auto max-w-3xl text-center">
    <p
      class="text-sm font-semibold uppercase tracking-[0.24em]"
      :class="tone === 'dark' ? 'text-red-300' : 'text-red-600'"
    >
      {{ eyebrow }}
    </p>
    <h2
      :id="headingId"
      class="mt-3 text-3xl font-bold tracking-tight sm:text-4xl"
      :class="tone === 'dark' ? 'text-white' : 'text-gray-900'"
    >
      {{ title }}
    </h2>
    <p
      v-if="description"
      class="mt-5 text-lg leading-relaxed"
      :class="tone === 'dark' ? 'text-gray-300' : 'text-gray-600'"
    >
      {{ description }}
    </p>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  headingId: string;
  eyebrow: string;
  title: string;
  description?: string;
  tone?: 'light' | 'dark';
}>(), {
  description: undefined,
  tone: 'light',
});
</script>
